import { withStatics } from './_util';
import { Modal as ModalMain } from './ModalMain';
import { alert } from './ModalAlert';
import { confirm } from './ModalConfirm';
import { useModal } from './useModal';
export var Modal = withStatics(ModalMain, {
    /**
     * API 的方式唤起一个 Alert 对话框
     *
     * *异步等待对话框关闭*
     */
    alert: alert,
    /**
     * API 的方式唤起一个确认对话框
     *
     * *异步返回布尔值，为 true 则表示用户确认，为 false 则表示用户取消*
     */
    confirm: confirm,
    /**
     * API 的方式唤起 Alert 或 Confirm
     *
     * *需要获取 React Context 信息时使用*
     */
    useModal: useModal,
});
